module.exports = __webpack_public_path__ + "img/rs.8e7d4784.svg";